import { render, staticRenderFns } from "./CpcMyAccountIntegration.vue?vue&type=template&id=46c8ac7b"
import script from "./CpcMyAccountIntegration.vue?vue&type=script&lang=ts"
export * from "./CpcMyAccountIntegration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports